import axios from 'axios'


let loadinginstace
//http request 拦截器
axios.interceptors.request.use(
	config => {
		if(localStorage.token) {
			config.headers.token = /*localStorage.token*/'ad2948c25423462b8c6d2f483a45660f';
		}
		if(sessionStorage.userInfo) {
			config.headers.loginName = sessionStorage.userInfo.loginName;
		}
		if(sessionStorage.communityId) {
			config.headers.communityId = sessionStorage.communityId;
		}
		return config;
	},
	err => {
		loadinginstace.close();
		Message.error({
			message: '加载超时'
		})
		return Promise.reject(err);
	});
// http response 拦截器
axios.interceptors.response.use(
	response => {
		//loadinginstace.close(); // 响应成功关闭loading
		return response;
	},
	error => {
		if(error.response) {
			console.log("error=========", error.response.status)
			switch(error.response.status) {
				// 401 清除token信息并跳转到登录页面(store.commit(types.LOGOUT);)
				case 401:
					{
						localStorage.removeItem("token");
						sessionStorage.removeItem("userInfo");
						sessionStorage.removeItem("communityId")
					};
					//跳转登录页面
					//					router.replace({
					//						path: '/login'
					////						query: {
					////							redirect: router.currentRoute.fullPath
					////						}
					//					})
					//window.location.href = "index.html#/login"
			}
		}
		Message.error({
			message: '加载失败'
		})
		return Promise.reject(error.response.data);
	});

const Plugin = {
	install(vue, options) {
		vue.prototype.$getInterfaceData = function(url, type, data) {
//			加token
			var configHeaders = {
				'Accept': 'application/json',
				'Content-Type': 'application/json; charset=UTF-8',
				'TK_REQUEST_SYS_CODE': 'SC513',
				'TK_REQUEST_MODULE_CODE': 'ESOC',
				'TK_REQUEST_NODE_IP': '10.130.214.119',
				'TK_BUSINESS_SERIALID': guid()
			};
			if(url=="/esocbes/user/userLoginHip" || url=="/esocbes/validatecode"){
			}else{
				let token=sessionStorage.getItem('token');
				 token = '724372e4-6fe6-4db8-b512-c0db819b87ab'
				let curOrgAry=JSON.parse(sessionStorage.getItem("orgCur"));
				let orgCd='',deptCd='';
				if(curOrgAry){
					orgCd=curOrgAry[0];
					deptCd=curOrgAry[1];
				}
				configHeaders = Object.assign({
//					'TK_AUTHEN_TOKEN': token,
//			        'Authorization':'Bearer ' + token,
			        'orgCd':orgCd,			//机构编码
			        'deptCd':deptCd			//部门编码
				}, configHeaders);
			}
			
			let Public = { //公共参数
				/*'srAppid': ""*/
			}
			let httpDefaultOpts = { //http默认配置
				method: type,
				url: url,
				timeout: 10000, //超时时间
				params: Object.assign(Public, data),
				data: data,
				headers: configHeaders,
				/*{
					'X-Requested-With': 'XMLHttpRequest',
					"Accept": "application/json",
					"Content-Type": "application/json; charset=UTF-8"
				},*/
				transformRequest: function(data) {
					// 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等...
					data = JSON.stringify(data);
					//console.log('请求的参数:', data);
					return data;
				},
				transformResponse: function(data) {
					// 这里提前处理返回的数据
					data = JSON.parse(data);
					//console.log('返回的数据:', data);
					return data;
				}
			}
			if(type == 'get') {
				delete httpDefaultOpts.data
			} else {
				delete httpDefaultOpts.params
			}

			let promise = new Promise(function(resolve, reject) {
				axios(httpDefaultOpts).then(
					(res) => {
						resolve(res)
					}
				).catch(
					(response) => {
						reject(response)
					}
				)
			})
			return promise
		}
	}
}
//生成随机uuid
function S4() {
	return(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
function guid() {
	return(S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export default Plugin;



// WEBPACK FOOTER //
// ./src/assets/js/getInterfaceData.js